"use client";

import { useEffect, useMemo } from "react";
import { useRuntimeConfig } from "@/config/runtime-config-context";
import {
	useIsDevToolsEnabled,
	useSetDevPayloadPreview,
} from "@/dev/dev-preview-provider";

interface PayloadPreviewProps {
	payload: unknown;
	flowPayload?: unknown;
}

/**
 * Headless publisher for the dev payload panel: lifts `{ flowContext,
 * submitPayload }` into the shared dev context, and clears it on unmount.
 */
export const PayloadPreview = ({
	payload,
	flowPayload,
}: PayloadPreviewProps) => {
	const isDevToolsEnabled = useIsDevToolsEnabled();
	const { showPayloadPreview: isPayloadPreviewEnabled } = useRuntimeConfig();
	const setPayloadPreview = useSetDevPayloadPreview();

	const previewPayload = useMemo(
		() => ({ flowContext: flowPayload, submitPayload: payload }),
		[flowPayload, payload]
	);

	const isEnabled = isDevToolsEnabled && isPayloadPreviewEnabled;

	useEffect(() => {
		if (!isEnabled) return;

		setPayloadPreview(previewPayload);
		return () => setPayloadPreview(undefined);
	}, [isEnabled, previewPayload, setPayloadPreview]);

	return null;
};
